import { render, staticRenderFns } from "./Navs.vue?vue&type=template&id=70c89eb9&"
import script from "./Navs.vue?vue&type=script&lang=js&"
export * from "./Navs.vue?vue&type=script&lang=js&"
import style0 from "./Navs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports